import { PrimeIcons } from 'primereact/api';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { CustomBranding, mapCustomBranding, Roles } from '../../models/User';
import { useAppSelector } from '../../redux/hooks';
import { selectUser } from '../../redux/reducers/userSlice';

const MonitoringNavBlock = () => {
  const userRedux = useAppSelector(selectUser);
  const miamiBrand =
    userRedux?.network?.customBranding &&
    mapCustomBranding[userRedux?.network?.customBranding] === CustomBranding.MIAMI;
  const navigate = useNavigate();
  return (
    <div className="flex flex-wrap gap-lg justify-content-center">
      <Button
        label={miamiBrand ? 'Skill Challenge History' : 'Assessment History'}
        icon="nc_icon-nc_challenge icon-md"
        iconPos="right"
        aria-label="Assessment History"
        rounded
        className="nc_button-square"
        outlined
        onClick={() => navigate('/assessment-history')}
        id="navBlockAssessmentHistory"
      />
      {userRedux?.roles.some(role => role.name === Roles.SITE_ADMIN || role.name === Roles.TEACHER) && (
        <Button
          label="Assignments"
          icon={PrimeIcons.BOOK}
          iconPos="right"
          aria-label="Assigments"
          rounded
          className="nc_button-square"
          outlined
          onClick={() => navigate('/assignments')}
          id="navBlockAssigments"
        />
      )}
      <Button
        label="Progress"
        icon="nc_icon-nc_diagnostic icon-md"
        iconPos="right"
        aria-label="Progress"
        rounded
        className="nc_button-square"
        outlined
        onClick={() => navigate('/progress')}
        id="navBlockProgress"
      />
      <Button
        label="Diagnostics"
        icon="nc_icon-nc_completed icon-md"
        iconPos="right"
        aria-label="Diagnostics"
        rounded
        className="nc_button-square"
        outlined
        onClick={() => navigate('/diagnostics')}
        id="navBlockDiagnostics"
      />
      <Button
        label="Reports Hub"
        icon="nc_icon-nc_export icon-md"
        iconPos="right"
        aria-label="Reports Hub"
        rounded
        className="nc_button-square"
        outlined
        onClick={() => navigate('/reports-hub')}
        id="navBlockReportsHub"
      />
    </div>
  );
};

export default MonitoringNavBlock;
